import { render, staticRenderFns } from "./TablePhieuThayDoiThongTin.vue?vue&type=template&id=78569f57&scoped=true"
import script from "./TablePhieuThayDoiThongTin.vue?vue&type=script&lang=js"
export * from "./TablePhieuThayDoiThongTin.vue?vue&type=script&lang=js"
import style0 from "./TablePhieuThayDoiThongTin.vue?vue&type=style&index=0&id=78569f57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78569f57",
  null
  
)

export default component.exports